<template>
    <div class="dialog-box">
        <div class="close" @click="handleClose">
            <i class="iconfont iconguanbi"></i>
        </div>
        <div class="content_box">
            <div class="content">
                <div class="head_go_name">
                    发送给：
                    <img v-if="chatdata.url" src="../../../../images/icon_z.png" alt="">
                    <p v-else :style="`background: ${chatdata.User_Gender === 0 ? '#fe86a8' : '#4da9ff'}`">
                        {{ chatdata.name }}
                    </p>
                </div>
                <div class="file_box">
                    <div class="file_item" v-for="(item, i) in files" :key="i">
                        <div class="left">
                            <i class="iconfont" :class="item.icon"></i>
                            <!-- <i class="iconfont icontxt"></i>
                            <i class="iconfont iconexcel"></i>
                            <i class="iconfont iconyasuowendang"></i> -->
                        </div>
                        <div class="right">
                            <p>{{ item.name }}</p>
                            <p>{{ Math.round(item.size / 1024 * 10) / 10 + 'kb' }}</p>
                        </div>
                    </div>
                </div>
                <div class="message_box">
                    <div class="title">
                        给朋友留言：
                    </div>
                    <div class="inp">
                        <el-input
                            type="textarea"
                            :rows="6"
                            placeholder="请输入留言"
                            v-model="value"
                        >
                        </el-input>
                    </div>
                </div>
            </div>
            <div class="btns">
                <el-button class="btn btn2" @click="handleClose">
                    取消
                </el-button>
                <el-button
                    class="btn btn1"
                    @click="saveFun"
                >
                    确认
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { matchType } from '@/views/messageCenter/js/matchType.js';
export default {
    name: 'sys-update',
    data() {
        return {
            files: [],
            chatdata: {},
            value: '',
        };
    },
    props: {
        extr: Object,
    },
    created() {
        if (this.extr) {
            this.chatdata = this.extr.chatdata;
            this.files = this.extr.files;
            this.files.forEach(item => {
                item.icon = matchType(item.name).icon;
            });
        }
    },
    methods: {
        handleClose() {
            this.extr.clearFun();
            this.$parent.hide();
        },
        saveFun() {
            this.extr.saveFun(this.value);
            this.$parent.hide();
        },
    },
};
</script>

<style lang="stylus" scoped>
.dialog-box
    position: relative;
    z-index: 11;
    width 100%;
    height 100%
    .close
        position absolute;
        right 10px;
        top 10px;
        width: 25px;
        height: 25px;
        padding-top 1px;
        display flex;
        justify-content center;
        align-items center;
        cursor pointer;
        .iconguanbi
            font-size 14px;
            color #000;
    .content_box
        box-sizing border-box
        width 100%;
        height 100%
        padding 20px 40px;
        background #fff;
        .content
            height calc(100% - 60px)
            overflow auto
            .head_go_name
                border-bottom 1px solid #e5e5e5
                margin-bottom 10px
                display flex
                line-height 50px
                img
                    width 40px
                    height 40px
                p
                    width: 40px;
                    height: 40px;
                    border-radius: 2px;
                    background: #15a9fe;
                    color: #fff;
                    font: 14px/40px "微软雅黑";
                    text-align: center;
            .file_box
                max-height 300px
                padding 10px
                overflow auto
                margin-bottom 20px
                .file_item
                    height 80px
                    display flex
                    .left
                        width 50px
                        margin 0 15px 15px 0
                        background #F7F7F7
                        i
                            font-size 45px
                    .right
                        flex 1
                        p
                            font-size: 14px;
                            font-family: SourceHanSansCN, SourceHanSansCN;
                            font-weight: 500;
                            color: #333333;
                            line-height: 32px;
            .message_box
                height 200px
                .title
                    color #999999
                    font-size 18px
                    margin-bottom 10px
        .btns
            height 60px
            display flex;
            justify-content space-around;
            align-items center;
            position absolute
            bottom 0
            left 50%
            transform translate(-50%)
            .btn
                display flex
                justify-content center;
                align-items center;
                width: 140px;
                height: 40px;
                border-radius: 1px;
                border: 1px solid #1577D2;
                color #1577D2;
                font-size 16px;
                &.btn1
                    background: #1577D2;
                    border-radius: 1px;
                    color #fff;
</style>
